import React, { FC } from 'react';

import { pagesMap } from '../../../constants';

import AssessmentIcon from '@mui/icons-material/AssessmentOutlined';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

import layoutBoardIcon from '../../../../assets/icons/layout-board.svg';
import homeIcon from '../../../../assets/icons/v2/home.svg';
import entitiesIcon from '../../../../assets/icons/v2/entities.svg';
import workspaceTemplatesIcon from '../../../../assets/icons/v2/workspace_templates.svg';
import sharedWithMeIcon from '../../../../assets/icons/v2/shared_with_me.svg';
import myAssetsIcon from '../../../../assets/icons/v2/my_assets_outlined.svg';
import manageGroupsIcon from '../../../../assets/icons/v2/manage_groups.svg';
import companyAssetsIcon from '../../../../assets/icons/v2/company_assets.svg';
import trashIcon from '../../../../assets/icons/v2/trash.svg';
import closeIcon from '../../../../assets/icons/x.svg';
import menuIcon from '../../../../assets/icons/menu-2.svg';
import styled from 'styled-components';

interface Props {
  icon: string | React.ReactNode;
}

const IconImg = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  display: block;
`;

const iconNameToComponentMap: Record<string, React.ReactNode> = {
  LayoutBoardIcon: <IconImg src={layoutBoardIcon} alt="layout board" />,
  FolderIcon: <FolderOutlinedIcon />,
  HomeIcon: <IconImg src={homeIcon} alt="home" />,
  EntitiesIcon: <IconImg src={entitiesIcon} alt="entities" />,
  WorkspaceTemplatesIcon: <IconImg src={workspaceTemplatesIcon} alt="workspace templates" />,
  SharedWithMeIcon: <IconImg src={sharedWithMeIcon} alt="shared with me" />,
  MyAssetsIcon: <IconImg src={myAssetsIcon} alt="my assets" />,
  CompanyAssetsIcon: <IconImg src={companyAssetsIcon} alt="company assets" />,
  ManageGroupsIcon: <IconImg src={manageGroupsIcon} alt="manage groups" />,
  TrashIcon: <IconImg src={trashIcon} alt="trash" />,
  CloseIcon: <IconImg src={closeIcon} alt="close" />,
  MenuIcon: <IconImg src={menuIcon} alt="menu" />,
  ThemesIcon: <BackupTableOutlinedIcon />,
  AssessmentIcon: <AssessmentIcon />,
  ShowChartIcon: <ShowChartIcon />,
  SettingsIcon: <SettingsOutlinedIcon />,
  StarterDecksIcon: <VideoLibraryOutlinedIcon />,
  AccountTreeOutlinedIcon: <AccountTreeOutlinedIcon />,
};

export const getMenuItemIconNameBySlug = (slug: string): string => {
  switch (slug) {
    case 'trash':
      return 'TrashIcon';
    case 'reports':
      return 'AssessmentIcon';
    case 'my-workspace':
      return 'HomeIcon';
    case pagesMap.workspaceTemplates.slug:
      return 'WorkspaceTemplatesIcon';
    case 'entities':
      return 'EntitiesIcon';
    case 'shared':
      return 'SharedWithMeIcon';
    case 'groups':
      return 'ManageGroupsIcon';
    case 'my-assets':
      return 'MyAssetsIcon';
    case 'settings':
      return 'SettingsIcon';
    case 'company-assets':
      return 'CompanyAssetsIcon';
    case 'themes':
      return 'ThemesIcon';
    case 'starter-decks':
      return 'StarterDecksIcon';
    case pagesMap.categories.slug:
      return 'AccountTreeOutlinedIcon';
    default:
      return 'FolderIcon';
  }
};

export const NgNavItemIcon: FC<Props> = ({ icon }) => {
  // If it's a string, look up in the map
  if (typeof icon === 'string') {
    return <>{iconNameToComponentMap?.[icon] || null}</>;
  }
  // Otherwise render the ReactNode directly
  return <>{icon}</>;
};
